import React, { useCallback } from 'react';
import { LightModal } from 'apps/sigma2-ui/src/components/ui/LightModal';
import { PrimaryButtonLightBg } from 'apps/sigma2-ui/src/components/PrimaryButtonLightBg';
import { SecondaryButtonLightBg } from 'apps/sigma2-ui/src/components/SecondaryButtonLightBg';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export interface UnsavedChangesModalProps {
  show: boolean;
  onConfirmLeave: () => void;
  onCancel: () => void;
}

export const UnsavedChangesModal = ({
  show,
  onConfirmLeave,
  onCancel,
}: UnsavedChangesModalProps) => {
  const language = useLanguage();

  const handleConfirm = useCallback(() => {
    onConfirmLeave();
  }, [onConfirmLeave]);

  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <LightModal
      width="w-96"
      showModal={show}
      onClose={handleCancel}
      title={
        <S2Typography
          translatedContent={language.unsavedChanges()}
          variant="headline-6"
          textColorVariant="gray-1000"
        />
      }
      actions={
        <div className="flex gap-2">
          <SecondaryButtonLightBg
            translatedContent={language.stay()}
            onClick={handleCancel}
            disabled={false}
          />
          <PrimaryButtonLightBg
            translatedContent={language.leave()}
            onClick={handleConfirm}
            disabled={false}
          />
        </div>
      }
    >
      <S2Typography
        translatedContent={language.unsavedChangesWarning()}
        variant="body-6"
        textColorVariant="gray-800"
      />
    </LightModal>
  );
};
